export default __webpack_public_path__ + "static/media/pag19.8246956c.jpg";